import isSubscribedThroughWeb from '../utils/subscription/subscribedThroughWeb';
import { premiumSubscriptionStatus } from '../utils/subscription/subscriptionStatus';

const NAMESPACE = 'me';

export const selectUserDetails = (state) => state?.[NAMESPACE]?.details;

export const selectSubscriptionStatus = (state) => {
  const userDetails = selectUserDetails(state);

  return userDetails?.currentSubscription?.status ?? premiumSubscriptionStatus.none;
};

export const selectSubscriptionProviderName = (state) => {
  const userDetails = selectUserDetails(state);

  return userDetails?.currentSubscription?.providerName;
};

export const selectIsUserSubscribed = (state) =>
  selectSubscriptionStatus(state) === premiumSubscriptionStatus.active;

export const selectIsExpiredWebSubscriber = (state) => {
  const status = selectSubscriptionStatus(state);
  const provider = selectSubscriptionProviderName(state);

  const hasExpiredStatus = status === premiumSubscriptionStatus.expired;
  // has expired web subscription status

  // the user data does not contain if the user is Active but has cancelled their subscription
  // we check this when they try to subscribe or go to their account subscription tab... they will
  // get redirected accordingly at that point
  return hasExpiredStatus && isSubscribedThroughWeb(provider);
};

export const selectUserAccountId = (state) => selectUserDetails(state)?.userId;

export const selectUsername = (state) => selectUserDetails(state)?.userName;
export const selectUserEmail = (state) => selectUserDetails(state)?.email;
export const getSelectChangedFavoritesForGuideId = (guideId) => (state) =>
  state?.[NAMESPACE]?.changedFavorites?.[guideId];
